import { ROUTES, TITLES, STAGE, DEV, PROD } from 'consts';

export const DELIVERY_SCHEDULE_MENU = {
  key: ROUTES.DELIVERY_SCHEDULE.ROOT,
  label: TITLES[ROUTES.DELIVERY_SCHEDULE.ROOT],
  environment: [DEV, STAGE, PROD],
  children: [
    {
      key: ROUTES.DELIVERY_SCHEDULE.APARTMENTS,
      label: TITLES[ROUTES.DELIVERY_SCHEDULE.APARTMENTS],
      environment: [DEV, STAGE, PROD],
    },
  ],
};
